// src/data/quotes.js
export const quotes = [
  {
    quote: "We made love as the sun beats, as coffins close.",
    author: "André Breton",
    source: "Manifestoes of Surrealism",
    sourceType: "book" 
  },

  {
    quote: "When I was a child, luxury was fur coats, evening dresses, and villas by the sea. Later on, I thought it meant leading the life of an intellectual. Now I feel that it is also being able to live out a passion for a man or a woman.",
    author: "Annie Ernaux",
    source: "Simple Passion",
    sourceType: "book"
  },

  {
    quote: "I began to realize that the only places where things were actually real was at this frontier between what you think is you and what you think is not you.",
    author: "David Whyte",
    source: "Seeking Language Large Enough",
    sourceType: "essay"
  },
  {
    quote: "My greatest regret was how much I believed in the future.",
    author: "Jonathan Safran Foer",
    source: "Extremely Loud and Incredibly Close",
    sourceType: "book"
  },
  {
    quote: "I write entirely to find out what I'm thinking.",
    author: "Joan Didion",
    source: "Why I Write",
    sourceType: "essay"
  },
  {
  quote: "Enormous night arise, / A cloud that is larger than the world / And a monster made of eyes.",
  author: "G. K. Chesterton",
  source: "A Second Childhood",
  sourceType: "poem"
},

{
  quote: "When we write 'the wine-dark sea' we are really writing something quite different from what Homer was writing.",
  author: "Jorge Luis Borges",
  source: "This Craft of Verse",
  sourceType: "book"
},
{
    quote: "Of course, you could just take off the blindfold and say, 'I think this game is stupid and I'm not playing it anymore.' And it must also be admitted that hitting the wall or wandering off in the wrong direction or tearing off the blindfold is as much a part of the game as is pinning the tail on the donkey.",
    author: "Maggie Nelson",
    source: "Bluets",
    sourceType: "book"
  },

  // {
  //   quote: "It occurred to me that writing should aim to do the same, to replicate the feeling of witnessing sexual intercourse, that feeling of anxiety and stupefaction, a suspension of moral judgment.",
  //   author: "Annie Ernaux",
  //   source: "Simple Passion",
  //   sourceType: "book"
  // },

  {
    quote: "If you took the monsters' point of view, everything they did made perfect sense. The trick was learning to think like a monster.",
    author: "Sy Montgomery",
    source: "The Soul of an Octopus: A Surprising Exploration into the Wonder of Consciousness",
    sourceType: "book"
  },
  {
    quote: "The appreciation of deception happens at the moment when the deception is undone, or by the imaginative creation of a less sophisticated reader who has not seen through the deceit.",
    author: "Allison Sharrock",
    source: "The Art of Deceit: Pseudolus and the Nature of Reading",
    sourceType: "essay"
  },
  {
    quote: "And nonetheless, my love, you have remained a shramana, nonetheless you do not love me, you love no human being. Is this not so?",
    author: "Hermann Hesse",
    source: "Siddhartha",
    sourceType: "book"
  },

  {
    quote: "But as I watched him smile back at me and zip his coat, I saw everything in the world build up and then everything in the world fall down again.",
    author: "Marina Keegan",
    source: "Cold Pastoral",
    sourceType: "essay"
  },
  {
    quote: "In the United States if you ask someone if they play chess and they say 'no,' it's because they don't know how the horsey moves. In Russia, if you ask someone if they play chess and they say 'no,' it's because they're only 1600.",
    author: "chess.com user \"Loomis\""
  },

  {
    quote: "All is well, the old man is dancing.",
    author: "Unknown (Roman lore)"
  },
  {
    quote: "Sydney Afriat is also a connoisseur of the art of good writing. He may well be the last remaining stylist writing exquisite economic prose with a liberal use of the subjunctive, a grammatical form long in decline in the Anglo-Saxon world (but much in evidence, even in daily discourse, of the language spoken in the Siena in which he lives). Moreover, he may belong to another select group of prose stylists who are also masters of some aspects of the mathematical method and its philosophy.",
    author: "Kumaraswamy Velupillai",
    source: "Book Review, The Market: Equilibrium, Stability, Mythology",
    sourceType: "article"
  },
  {
    quote: "A lot of people have said that if Tal had looked after his health, if he hadn't led such a dissolute life... and so forth. But with people like Tal, the idea of 'if only' is just absurd. He wouldn't have been Tal then.",
    author: "Salli Landau, Chess Week (Russia), 2003"
  },
  {
    quote: "I envy you going to Oxford: it is the most flower-like time of one's life. One sees the shadow of things in silver mirrors. Later on, one sees the Gorgon's head, and one suffers, because it does not turn one to stone.",
    author: "Oscar Wilde, in a letter to Louis Wilkinson, 1898"
  },
  {
    quote: "The will to live cannot be overestimated as a stimulant to longevity. Indeed, Dr. Dannyboy goes so far as to claim that ninety percent of all deaths are suicides.",
    author: "Tom Robbins",
    source: "Jitterbug Perfume",
    sourceType: "book"
  },

  {
    quote: "He totally can, but refuses to draw a straight line.",
    author: "Thumpmonks, on the game developer Mateusz Skutnik, 2018"
  },
  {
    quote: "The fire of this kiss was still around him like a colored glory when he returned home. He could not lay it aside in the hall as he did this black felt hat, and when he came into the bedroom he thought that his wife must see that halo.",
    author: "Vladimir Nabokov",
    source: "Laughter in the Dark",
    sourceType: "book"
  },

  {
    quote: "Early in the novel that Tereza clutched under her arm when she went to visit Tomas, Anna meets Vronsky in curious circumstances: they are at the railway station when someone is run over by a train. At the end of the novel, Anna throws herself under a train. This symmetrical composition––the same motif appears at the beginning and at the end––may seem quite 'novelistic' to you, and I am willing to agree, but only on condition that you refrain from reading such notions as 'fictive,' 'fabricated,' and 'untrue to life' into the word 'novelistic.' Because human lives are composed in precisely such a fashion.",
    author: "Milan Kundera",
    source: "The Unbearable Lightness of Being",
    sourceType: "book"
  },
  {
    quote: "I know it's a kick in the pants to hear the problem is you, but it's also fucking fantastic. You are, after all, the only person you can change.",
    author: "Cheryl Strayed",
    source: "The Rumpus Advice Column #38: Romantic Love is Not a Competitive Sport",
    sourceType: "essay"
  },
  {
    quote: "Lord, I confess I want the clarity of catastrophe but not the catastrophe. Like everyone else, I want a storm I can dance in. I want an excuse to change my life.",
    author: "Franny Choi",
    source: "Catastrophe Is Next to Godliness",
    sourceType: "poem"
  },
 
  {
    quote: "And presently I was driving through the drizzle of the dying day, with the windshield wipers in full action but unable to cope with my tears.",
    author: "Vladimir Nabokov",
    source: "Lolita",
    sourceType: "book"
  },
  // {
  //   quote: "I want pure colors, melting clouds, accurately drawn details, a sunburst above a receding road with the light reflected in furrows and ruts, after rain. And no girls.",
  //   author: "Vladimir Nabokov, on the cover of Lolita"
  // },

  {
    quote: "It is completely unimportant. That is why it is so interesting.",
    author: "Agatha Christie",
    source: "The Murder of Roger Ackroyd",
    sourceType: "book"
  },
  {
    quote: "I wondered if that was how forgiveness budded; not with the fanfare of epiphany, but with pain gathering its things, packing up, and slipping away unannounced in the middle of the night.",
    author: "Khaled Hosseini",
    source: "The Kite Runner",
    sourceType: "book"
  },
  {
    quote: "The best meditations move at breakneck pace, the second best are completely stationary. Aurelius was a master horseman, but know that it was the horse that moved and not the emperor.",
    author: "Kimathi Muiruri",
    source: "so now You have seen free men",
    sourceType: "poem"
  },
  {
    quote: "The #1 programmer excuse for legitimately slacking off: 'my code's compiling!'",
    author: "xkcd",
    source: "Compiling",
    sourceType: "article"
  },
  {
    quote: "About dreams. It is usually taken for granted that you dream of something that has made a particularly strong impression on you during the day, but it seems to me it's just the contrary. Often it's something you paid no attention to at the time — a vague thought that you didn't bother to think out to the end, words spoken without feeling and which passed unnoticed — these are the things that return at night, clothed in flesh and blood, and they become the subjects of dreams, as if to make up for having been ignored during waking hours.",
    author: "Boris Pasternak", 
    source: "Doctor Zhivago",
    sourceType: "book"
  },
  {
    quote: "Everything is like something else. / I should have waited before I learned this.",
    author: "John Ashbery",
    source: "No Longer Very Clear",
    sourceType: "poem"
  },
  {
    quote: "If we were not something more than unique human beings, if each one of us could really be done away with once and for all by a single bullet, storytelling would lose all purpose. But every man is more than just himself; he also represents the unique, the very special and always significant and remarkable point at which the world's phenomena intersect, only once in this way and never again.",
    author: "Hermann Hesse",
    source: "Demian",
    sourceType: "book"
  },
  {
    quote: "Last year, in October, it was me who was starting a love affair, whose excruciating outcome was naturally to be expected. But going to the ends of misery first means going to the ends of happiness. Yesterday, it came to me with certainty that I write my love stories and live my books, in a perpetual round dance.",
    author: "Annie Ernaux",
    source: "Getting Lost",
    sourceType: "book"
  },
  {
    quote: "I stopped watching for ridicule, the scorpion's tail hidden in his words. He said what he meant; he was puzzled if you did not. Some people might have mistaken this for simplicity. But is it not a sort of genius to cut always to the heart?",
    author: "Madeline Miller",
    source: "The Song of Achilles",
    sourceType: "book"
  },
  {
    quote: "You think your pain and your heartbreak are unprecedented in the history of the world, but then you read.",
    author: "James Baldwin, LIFE magazine interview, 1963",
  },
  {
    quote: "What's the point of being in love if I can't be clever?",
    author: "Plautus",
    source: "Casina",
    sourceType: "book"
  },

  {
    quote: "A good answer must be reinvented many times, from scratch.",
    author: "Richard Powers",
    source: "The Overstory",
    sourceType: "book"
  },
  
  // {
  //   quote: "From the very beginning, and throughout the whole of our affair, I had the privilege of knowing what we all find out in the end: the man we love is a complete stranger.",
  //   author: "Annie Ernaux",
  //   source: "Simple Passion",
  //   sourceType: "book"
  // },

  {
    quote: "We love life if we find a way to it.",
    author: "Mahmoud Darwish",
    source: "And We Love Life",
    sourceType: "poem"
  },

  // {
  //   quote: "A part of me is happy that Al-Maamdani got bombed, because that might mean the end of the Aggression. After you strike a hospital, where do you go from there?",
  //   author: "Plestia Alaqad",
  //   source: "The Eyes of Gaza",
  //   sourceType: "book"
  // },

  {
    quote: "The beast which Giovanni had awakened in me would never go to sleep again; but one day I would not be with Giovanni any more.",
    author: "James Baldwin",
    source: "Giovanni's Room",
    sourceType: "book"
  },

  {
    quote: "I wanted to be an artist but I wanted my work to matter.",
    author: "Patti Smith",
    source: "Just Kids",
    sourceType: "book"
  },
  
  {
    quote: "Your absence has gone through me / Like thread through a needle. / Everything I do is stitched with its color.",
    author: "W.S. Merwin",
    source: "Separation",
    sourceType: "poem"
  },

  {
    quote: "The day someone loves you, the weather's marvelous.",
    author: "Valérie Perrin",
    source: "Fresh Water for Flowers",
    sourceType: "book"
  },

  {
    quote: "Years before I had my son I heard of an artist explaining why she had decided to become a mother: I didn’t want to reach the end of my life intact.",
    author: "Sarah Manguso",
    source: "The Grand Shattering",
    sourceType: "essay"
  },

    {
    quote: "Why does the image of two red butterflies on a T-shirt make me cry? We don’t know how we will grieve until we grieve.",
    author: "Chimamanda Ngozi Adichie",
    source: "Notes on Grief",
    sourceType: "essay"
  },
    {
    quote: "Every statement I make today is backed up by sources, solid sources. These are not assertions. What we're giving you are facts and conclusions based on solid intelligence.",
    author: "Colin Powell",
    source: "Address to the United Nations Security Council, 2003",
    sourceType: "article"
  },

  {
    quote: "Hunger allows no choice / To the citizen or the police; / We must love one another or die.",
    author: "W.H. Auden",
    source: "September 1, 1939",
    sourceType: "poem"
  },

  {
    quote: "I just wanted to retain the whole memory of my life.",
    author: "Sarah Manguso",
    source: "Ongoingness: The End of a Diary",
    sourceType: "book"
  },

  {
    quote: "The idea that the poor should have leisure has always been shocking to the rich.",
    author: "Bertrand Russell",
    source: "In Praise of Idleness",
    sourceType: "essay"
  },

  {
    quote: "There was no pleasure I did not experience. I threw the pearl of my soul into a cup of wine. I went down the primrose path to the sound of flutes. I lived on honeycomb. But to have continued the same life would have been wrong because it would have been limiting. I had to pass on. The other half of the garden had its secrets for me also.",
    author: "Oscar Wilde",
    source: "De Profundis",
    sourceType: "book"
  },

  {
    quote: "Money doesn't spend its life / Money only spends the night.",
    author: "Molly Nilsson",
    source: "Money Never Dreams",
    sourceType: "poem"
  },

  // {
  //   quote: "The ruins proclaim the building was beautiful.",
  //   author: "Mohsin Hamid",
  //   source: "The Reluctant Fundamentalist",
  //   sourceType: "book"
  // },
  {
    quote: "There are no borders, only wind.",
    author: "Cameron Awkward-Rich",
    source: "Meditations in an Emergency",
    sourceType: "poem"
  },
{
  quote: "This dream is not mine, they said, but the dream replied, You do not yet know your dreams.",
  author: "José Saramago",
  source: "Blindness",
  sourceType: "book"
},
{
  quote: "A horse gives way to another horse and then suddenly there are two horses, just like that. That's how I loved you.",
  author: "Ada Limón",
  source: "What I Didn't Know Before",
  sourceType: "poem"
},
{
  quote: "Fascism, socialism, civil war in Spain and things of that sort ... I've been stricken with misgiving, what I mean is what if those two youngsters are right? ... But if they were right my life wouldn't make any sense, it wouldn't make any sense to have read literature at Coimbra and always thought that literature was the most important thing in the world ... in fact nothing would make any sense at all.",
  author: "Antonio Tabucchi",
  source: "Pereira Maintains",
  sourceType: "book"
},
{
  quote: "Things might have worked out rather differently if I had turned around; then again, things might have worked out exactly the same.",
  author: "Mohsin Hamid",
  source: "The Reluctant Fundamentalist",
  sourceType: "book"
},
{
  quote: "A conversation is like having a catch with someone. A good partner tosses the ball directly into your glove, making it almost impossible for you to miss it; when he is on the receiving end, he catches everything sent his way, even the most errant and incompetent throws.",
  author: "Paul Auster",
  source: "Moon Palace",
  sourceType: "book"
},
{
  quote: "So it makes you feel slightly insane or something, to have those things inside you, when they seem to have no reality here.",
  author: "David Szalay",
  source: "Flesh",
  sourceType: "book"
},
{
  quote: "My inmost being hardly knows / If it's my demency that rambles / Or your own melody that grows.",
  author: "Vladimir Nabokov",
  source: "The Gift",
  sourceType: "book"
},
{
  quote: "Say not, 'I have found the truth,' but rather, 'I have found a truth.'",
  author: "Kahlil Gibran",
  source: "The Prophet",
  sourceType: "book"
},
  

];